import { getWindow } from "./get-window";

export const getBackgroundUrl = (path: string) => {
    const host = getWindow().__HOST__;

    if (!host) {
        return "";
    }

    const [, domain, tld] = host.split(".");
    const isLocalDevelopment = `${domain}.${tld}` === "r360online.test";

    const newPath = isLocalDevelopment ? path.replace("https", "http") : path;

    return `url(${newPath})`;
};
